import React from 'react';

const Explainer = ({neighborhoods_samples}) => {

  let ready = false;
  if (neighborhoods_samples) ready = true;

  return (
    <div className={"fixed top-0 center h6 left-0 right-0 px2 py05 white " + (ready ? 'display-none' : '')}
      style={{
        background: '#6c5ecc',
        zIndex: 6,
        fontSize: '0.75rem'
      }}
    >
      Loading samples...
    </div>
  )

}

export default Explainer;


/** WEBPACK FOOTER **
 ** ./src/components/Loader.js
 **/